// frontend/src/components/auth/SSOButton.tsx

import React from "react";
import styles from "./SSOButton.module.css";

const SSOButton: React.FC = () => {
  return (
    <div className={styles.SSOButton}>
      {/* Component code for SSOButton */}
      <SSOButton /> component
    </div>
  );
};

export default SSOButton;
